<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <BillDetail slot-scope="{data}" :form-data="data" ></BillDetail>
  </l-cache>
</template>
<script>
import BillDetail from './billDetail'
export default {
  name: 'billDetailBox',
  components: {BillDetail},
  methods: {
    async getItem (key) {
      let pagination = {pages: 1, rowsPerPage: 10}
      let {items, amount} = await this.$store.dispatch('pay/getBillList', {pagination: pagination, search: {key: 'id', value: this.$route.query.id}})
      if (items.length === 0) {
        this.$L.alert('error', {message: '未查询到该订单'})
        return {}
      }
      else {
        return items[0]
      }
    }
  }
}
</script>
